import { clsx } from "clsx";
import React from "react";

export type ButtonFooterProps = {
  children: React.ReactNode;
  className?: string;
  disclaimer?: React.ReactNode;
};

/**
 * ButtonFooter - A footer component for button actions
 * - Automatically stacks multiple buttons vertically with gap-3
 * - All buttons are full-width by default
 * - Optionally displays a disclaimer above the buttons
 */
export const ButtonFooter: React.FC<ButtonFooterProps> = ({
  children,
  className,
  disclaimer,
}) => {
  return (
    <div className={clsx("flex flex-col gap-4", className)}>
      {disclaimer && <div>{disclaimer}</div>}
      <div className="flex flex-col w-full gap-3">{children}</div>
    </div>
  );
};
